function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint class-methods-use-this: "off" */
/* eslint no-unused-vars: "off" */

/**
 * Some events we listen to are a native mouse event, and others are wrapped with React's SyntheticEvent.
 * The GridMouseHandler shouldn't care though - the properties it accesses should be common on both types of events.
 */

/**
 * Define a region in the grid that interacts with the mouse on a grid.
 * Return true from any of the events to indicate they're consumed, and stopPropagation/preventDefault will be called.
 */
export class GridMouseHandler {
  // What order this mouse handler should trigger in. Smaller numbers trigger first
  // Default to well below any of the GRID mouse handlers 100-1000+
  constructor() {
    var order = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5000;
    _defineProperty(this, "order", void 0);
    // Cursor to use if this returns any truthy value including { stopPropagation: false, preventDefault: false }
    _defineProperty(this, "cursor", null);
    this.order = order;
  }
  onDown(gridPoint, grid, event) {
    return false;
  }
  onMove(gridPoint, grid, event) {
    return false;
  }
  onDrag(gridPoint, grid, event) {
    return false;
  }
  onLeave(gridPoint, grid, event) {
    return false;
  }
  onClick(gridPoint, grid, event) {
    return false;
  }
  onContextMenu(gridPoint, grid, event) {
    return false;
  }
  onDoubleClick(gridPoint, grid, event) {
    return false;
  }
  onUp(gridPoint, grid, event) {
    return false;
  }
  onWheel(gridPoint, grid, event) {
    return false;
  }
}
export default GridMouseHandler;
//# sourceMappingURL=GridMouseHandler.js.map